import { http } from '../client';
import type { CallOptions, ItemList } from '../types';
import type { AdminApi, AdminPage, ApiCredential, RoleDetail, RoleSummary, StaffDetail, StaffMember } from './admin';

const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });

export const adminHttp: AdminApi = {
  listStaff: (q, opts) =>
    http.get<AdminPage<StaffMember>>('api', '/staff', {
      query: { q: q.q, status: q.status, role: q.role, locked: q.locked, before: q.before, limit: q.limit },
      ...rd(opts),
    }),
  getStaffMember: (id, opts) => http.get<StaffDetail>('api', `/staff/${seg(id)}`, rd(opts)),
  listRoles: (opts) => http.get<ItemList<RoleSummary>>('api', '/roles', rd(opts)),
  getRole: (code, opts) => http.get<RoleDetail>('api', `/roles/${seg(code)}`, rd(opts)),
  listApiCredentials: (q, opts) =>
    http.get<AdminPage<ApiCredential>>('api', '/api-credentials', {
      query: { owner_type: q.owner_type, status: q.status, q: q.q, before: q.before, limit: q.limit },
      ...rd(opts),
    }),
};
